export default function ProjectIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="37"
      height="37"
      viewBox="0 0 37 37"
    >
      <defs>
        <clipPath id="clip-path">
          <rect id="Rectangle_698" data-name="Rectangle 698" width="12.456" height="13.134" fill="currentColor" />
        </clipPath>
      </defs>
      <rect id="Rectangle_705" data-name="Rectangle 705" width="37" height="37" rx="18.5" opacity="0" />
      <g id="Group_1941" data-name="Group 1941" transform="translate(11.57 10.506)">
        <g id="Group_1940" data-name="Group 1940" clipPath="url(#clip-path)">
          <path
            id="Path_1239"
            data-name="Path 1239"
            d="M9.431,83.13a1.22,1.22,0,1,1,1.22-1.22,1.22,1.22,0,0,1-1.22,1.22M12.456,85.6V78.224a1.2,1.2,0,0,0-1.195-1.195H1.195A1.2,1.2,0,0,0,0,78.224V85.6a1.2,1.2,0,0,0,1.195,1.195H11.261A1.2,1.2,0,0,0,12.456,85.6"
            transform="translate(0 -73.657)"
            fill="currentColor"
          />
          <path id="Path_1241" data-name="Path 1241" d="M62.691,2.756,60.375,1.4,54.483,2.756Z" transform="translate(-52.098 -0.688)" fill="currentColor" />
        </g>
      </g>
    </svg>
  );
}